function Main() {
    return (
        <main className="main">
            <h2>Загальні компетентності</h2>
            <table>
                <tr>
                    <td>
                        Умовне позначення
                    </td>
                    <td>
                        Загальні компетентності
                    </td>
                </tr>
                <tr>
                    <td>
                        ЗК.01
                    </td>
                    <td>
                        Здатність діяти відповідально та свідомо; реалізовувати свої права і обов’язки як члена
                        суспільства і громадянина держави, усвідомлювати свої обов’язки і відповідальність перед
                        суспільством/громадою за результати професійної діяльності, усвідомлювати
                        цінності громадянського (вільного демократичного) суспільства та необхідність його сталого
                        розвитку, верховенства права, прав і свобод людини і громадянина в Україні (громадянська
                        компетентність).
                    </td>
                </tr>
                <tr>
                    <td>
                        ЗК.02
                    </td>
                    <td>
                        Здатність до ефективної комунікації і міжособистісної взаємодії, роботи в команді, спілкування з
                        представниками інших професійних груп різного рівня (соціальна компетентність.)
                    </td>
                </tr>
                <tr>
                    <td>
                        ЗК.О3
                    </td>
                    <td>
                        Здатність до усвідомлення, цінування й поваги багатоманітності та мультикультурності у
                        суспільстві, творчого самовираження (культурна компетентність).
                    </td>
                </tr>

                <tr>
                    <td>
                        ЗК.04
                    </td>
                    <td>
                        Здатність до впевненого і критичного використання цифрових технологій і ресурсів, цифрового
                        освітнього середовища у професійній діяльності, повсякденному житті, комунікації (цифрова
                        компетентність).
                    </td>
                </tr>
                <tr>
                    <td>
                        ЗК.05
                    </td>
                    <td>
                        Здатність до генерування нових ідей, виявлення ініціативи та підприємливості (підприємницька
                        компетентність).
                    </td>
                </tr>
                <tr>
                    <td>
                        ЗК.06
                    </td>
                    <td>
                        Здатність усвідомлювати свої професійні можливості та діяти лише в межах рівня професійної
                        підготовленості, діяти на основі етичних міркувань (мотивів), доброчесності, соціальної
                        відповідальності, поваги до різноманітності та мультикультурності (етична
                        компетентність)
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {Main}